import * as React from "react";
import { forwardRef } from "react";
const SvgIconBackTopMobile = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 11, height: 18, viewBox: "0 0 11 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m13.515 14.781 1.266 1.266 7.734 7.734 1.266-1.266-7.734-7.734 7.734-7.734-1.266-1.266-7.734 7.734z", "data-name": "Path 1126", transform: "translate(-13.215 -5.781)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconBackTopMobile);
export { ForwardRef as ReactComponent };
